/**
 * External dependencies
 */
import React from "react";
import { connect } from "react-redux";
import { map, join, split } from "lodash";

/**
 * Internal dependencies
 */
import { getFilters } from "state/ui/dashboard-filter/selectors";
import TagGroup from "components/tag/tag-group";
import Tag from "components/tag";
import { removeFilter } from "state/ui/dashboard-filter/actions";

/**
 * Style dependencies
 */
import "./styles.scss";

const DashboardFilterTags = ({ filters, ...props }) => {
  const createLabel = ({ member, values }) => {
    return `${split(member, ".", 2)[0]}: ${join(values, ", ")}`;
  };

  return (
    <TagGroup>
      {map(filters, (filter) => (
        <Tag
          key={filter.member}
          label={createLabel(filter)}
          icon={{ name: "MdClose" }}
          onClick={() => props.removeFilter(filter.member)}
        />
      ))}
    </TagGroup>
  );
};

export default connect(
  (state) => ({
    filters: getFilters(state),
  }),
  {
    removeFilter,
  }
)(DashboardFilterTags);
